module.exports = __webpack_public_path__ + "static/media/congrats_bg.55eb485c.png";